export default function Solution() {
  const benefits = [
    {
      icon: 'ri-mail-send-fill',
      title: 'The Letter',
      description: 'A lawyer-signed demand letter that makes the bully realize you\'re not bluffing.'
    },
    {
      icon: 'ri-car-fill',
      title: 'The Defense',
      description: 'Traffic tickets, contract disputes, identity theft—covered.'
    },
    {
      icon: 'ri-safe-fill',
      title: 'The Safety Net',
      description: 'Will prep, document review, legal consultations—unlimited.'
    }
  ];

  return (
    <section className="relative bg-gradient-to-b from-[#0f1d2e] to-[#0a1628] py-16 sm:py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center space-y-6 sm:space-y-8 mb-12 sm:mb-16">
          {/* SEO H2 - Secondary Keyword */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-tight" style={{ fontFamily: "'Roboto', sans-serif" }}>
            Legal protection for homeowners against contractors, HOAs and insurance companies.
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="relative bg-[#0f1d2e] border-2 border-[#DC2626]/30 rounded-xl p-8 hover:border-[#DC2626] transition-all duration-300 group"
            >
              {/* Glow Effect Behind Icon */}
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-gradient-radial from-[#DC2626]/40 via-[#DC2626]/20 to-transparent blur-2xl scale-150 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative w-20 h-20 mx-auto bg-[#DC2626]/20 rounded-2xl flex items-center justify-center group-hover:bg-[#DC2626]/30 transition-all duration-300">
                  <i className={`${benefit.icon} text-5xl text-[#DC2626] group-hover:scale-110 transition-transform duration-300`}></i>
                </div>
              </div>

              <h3 className="text-2xl font-black text-white mb-4 text-center" style={{ fontFamily: "'Roboto', sans-serif" }}>
                {benefit.title}
              </h3>
              
              <p className="text-gray-300 text-center leading-relaxed">
                {benefit.description}
              </p>

              {/* Hover Arrow */}
              <div className="mt-6 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-line text-2xl text-[#DC2626]"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#0a0a0a]/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 sm:p-8 hover:border-[#DC2626] transition-all duration-300">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#DC2626] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-send-fill text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-white">Lawyer Demand Letter Service</h3>
          </div>
          <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
            Send a letter on law firm letterhead to anyone who's trying to push you around. Contractors, HOAs, insurance companies—they all fold when they see you have legal backing.
          </p>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#DC2626]/10 to-[#DC2626]/5 border-2 border-[#DC2626] rounded-xl px-8 py-6">
            <p className="text-2xl md:text-3xl text-white font-black mb-2">
              All of this. <span className="text-[#DC2626]">$30/month</span>.
            </p>
            <p className="text-gray-400">No retainers. No hourly fees. No surprises.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
